import styled from "styled-components";
import { sectionContentWidth } from "./sectionLayout";

export const MenuTitle = styled.h1`
  ${sectionContentWidth}
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  margin-top: 0;
  margin-bottom: 0;
  font-family: "Delius Unicase", cursive;
`;
